import React from 'react';
import { ImSpinner4 } from 'react-icons/im';

const Spinner = ({ displaytext }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75">
      <div className="flex flex-col items-center">
        <div className="rounded-full animate-spin text-indigo-500">
          <ImSpinner4 className="w-8 h-8" />
        </div>
        {displaytext && (
          <p className="mt-4 text-lg font-semibold text-gray-700">{displaytext}</p>
        )}
      </div>
    </div>
  );
};

export default Spinner;